var map = {
	"./on-after-seconds.json": 30995,
	"./on-after-step.json": 32343,
	"./on-before-step.json": 58501,
	"./on-click.json": 15724,
	"./on-cloned.json": 20381,
	"./on-every-seconds.json": 57431,
	"./on-hit.json": 67554,
	"./on-key-press.json": 94651,
	"./on-move-end.json": 59324,
	"./on-move-start.json": 11011,
	"./on-out-of-bounds.json": 4972,
	"./on-pointer-move.json": 91138,
	"./on-pointer-press.json": 28034,
	"./on-pointer-release.json": 68131,
	"./on-start-end.json": 47615,
	"./on-start.json": 23233,
	"./on-update.json": 35379,
	"models/block/blocks/event/blueprints/on-after-seconds.json": 30995,
	"models/block/blocks/event/blueprints/on-after-step.json": 32343,
	"models/block/blocks/event/blueprints/on-before-step.json": 58501,
	"models/block/blocks/event/blueprints/on-click.json": 15724,
	"models/block/blocks/event/blueprints/on-cloned.json": 20381,
	"models/block/blocks/event/blueprints/on-every-seconds.json": 57431,
	"models/block/blocks/event/blueprints/on-hit.json": 67554,
	"models/block/blocks/event/blueprints/on-key-press.json": 94651,
	"models/block/blocks/event/blueprints/on-move-end.json": 59324,
	"models/block/blocks/event/blueprints/on-move-start.json": 11011,
	"models/block/blocks/event/blueprints/on-out-of-bounds.json": 4972,
	"models/block/blocks/event/blueprints/on-pointer-move.json": 91138,
	"models/block/blocks/event/blueprints/on-pointer-press.json": 28034,
	"models/block/blocks/event/blueprints/on-pointer-release.json": 68131,
	"models/block/blocks/event/blueprints/on-start-end.json": 47615,
	"models/block/blocks/event/blueprints/on-start.json": 23233,
	"models/block/blocks/event/blueprints/on-update.json": 35379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45561;